import axios from "axios";
import type { PeriodSummaryIn } from "@/pages/human-resources/time-management/endpoints/analysis/inout/PeriodSummaryIn.ts";
import type { PeriodSummary } from "@/pages/human-resources/time-management/business/analysis/PeriodSummary.ts";

export async function getPeriodSummary(
  params: PeriodSummaryIn,
): Promise<PeriodSummary[]> {
  const { data } = await axios.get<PeriodSummary[]>(
    `/api/hr/schedule/analysis/periodsummary`,
    {
      params,
      paramsSerializer: {
        indexes: null,
      },
    },
  );
  return data;
}

export const periodSummaryQueryKey = {
  all: ["schedule_analysis_period_summary"] as const,
  forSiteAndDateAndModes: (params: PeriodSummaryIn) =>
    [
      ...periodSummaryQueryKey.all,
      params.domainId,
      params.siteId,
      params.date,
      params.modes,
      params.range,
    ] as const,
};
